export default {
	'weight-and-quality-certificates': 'Certificados de peso y calidad',
    'weight-and-quality-certificate': 'Certificado de peso y calidad',
    'add-a-weight-and-quality-certificate': 'Agregar certificado de peso y calidad'
}